import { Component, Input, ViewChildren, QueryList, AfterContentInit, OnChanges, SimpleChanges, AfterViewInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { Support } from '@app/_helpers';
import { HashDirective } from '@blocks/blocks.directive';
import * as _ from 'lodash';
 import { NgIf, NgFor } from '@angular/common';
@Component({
    selector: 'app-block-grid',
    templateUrl: './block-grid.component.html',
    styleUrls: ['./block-grid.component.scss'],
    standalone: true,
    imports: [NgIf, HashDirective, NgFor]
})
export class BlockGridComponent implements AfterViewInit,OnChanges {
    @Input() grid = "grid grid-cols-12";
    @Input() span = "col-span-1";
    @Input() gridClass = "";
    @Input() id;
    @Input() gap;
    @Input() parentItem;
    @Input() isMainLayout = false;
    @Input() item;
    @Input() blocksRef;
    @Input() agent = { mobile: true, desktop: true };
    @Input() customGrid;
    _customGrid = '';
    @Output() loadedBlock: EventEmitter<any> = new EventEmitter(null);


    constructor() { 
      
        
    }
    ngOnChanges(changes: SimpleChanges): void {
        if(changes.customGrid?.currentValue){
            let customGrid = changes.customGrid.currentValue;
            let gridList = [];
            let agents = ['desktop','tablet', 'mobile'];
            if(Support.numberToBoolean(customGrid.active)){
                _.forEach(agents,agent => {
                    if(Support.numberToBoolean(customGrid[agent].active)){
                        if(customGrid[agent].gap){
                            gridList.push(`${agent}:${customGrid[agent].gap}`);
                        }
                        if(customGrid[agent].grid){
                            let _grid =  _.split(customGrid[agent].grid,' ');
                            _grid = _grid.map(g => `${agent}:${g}` );
                             gridList.push( _.join(_grid,' '));
                        }
                        if(customGrid[agent].span){
                            gridList.push(`${agent}:${customGrid[agent].span}`);
                        }
                    }
                })
                
                 
                this._customGrid = _.join(gridList,' ')
            }
        }
    }

     @ViewChild(HashDirective) private hash: QueryList<HashDirective>;
    ngAfterViewInit(): void {
        this.blocksRef.push(this.hash);
        this.loadedBlock.emit(true);
    }
}
